import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._mask = (e) => {
      const digits = e.target.value.replace(/\D/g, "").slice(0, 6)
      e.target.value = digits.length > 2
        ? digits.slice(0, 2) + "/" + digits.slice(2)
        : digits
    }
    this.element.addEventListener("input", this._mask)
  }

  disconnect() {
    this.element.removeEventListener("input", this._mask)
  }
}